module.exports = __webpack_public_path__ + "img/6.18f3aa30.jpg";